"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONColumnsSectionPropertiesConverter = void 0;
var section_column_properties_1 = require("../../../section/section-column-properties");
var json_section_enums_1 = require("../../enums/json-section-enums");
var JSONColumnsSectionPropertiesConverter = (function () {
    function JSONColumnsSectionPropertiesConverter() {
    }
    JSONColumnsSectionPropertiesConverter.convertFromJSON = function (jsonColumns) {
        var result = [];
        for (var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++) {
            var jsonColumn = jsonColumns_1[_i];
            result.push(new section_column_properties_1.SectionColumnProperties(jsonColumn[json_section_enums_1.JSONColumnInfoProperty.Width], jsonColumn[json_section_enums_1.JSONColumnInfoProperty.Space]));
        }
        return result;
    };
    JSONColumnsSectionPropertiesConverter.convertToJSON = function (columns) {
        var result = [];
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var column = columns_1[_i];
            var jsonColumn = {};
            jsonColumn[json_section_enums_1.JSONColumnInfoProperty.Width] = column.width;
            jsonColumn[json_section_enums_1.JSONColumnInfoProperty.Space] = column.space;
            result.push(jsonColumn);
        }
        return result;
    };
    return JSONColumnsSectionPropertiesConverter;
}());
exports.JSONColumnsSectionPropertiesConverter = JSONColumnsSectionPropertiesConverter;
